<script>
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwButton from '@/components/generic/tw-button.vue'
import ImportFundraisersForOrganization from '@/components/imports/import-fundraisers-for-organization.vue'

export default {
  name: 'ImportOrganizationForUser',
  components: { ImportFundraisersForOrganization, TwButton, TwLoadingSpinner, TwCard },
  props: {
    userOld: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      LoadingFetchingOrganization: false,
      LoadingImportingOrganization: false,
      ValidationErrorMessage: null,
      Organization: null,
      ImportedOrganization: null
    }
  },
  mounted() {
    this.fetchOrganizationForUserOld()
    this.fetchImportedOrganization()
  },
  methods: {
    async fetchOrganizationForUserOld() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingOrganization = true
        const { data } = await axios.get(`/api/v1/import/old-organization/${this.userOld.organization_id}`)
        this.Organization = data
        this.LoadingFetchingOrganization = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingOrganization = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        this.$notify('An error occurred: ' + e.response.data.message, 'error')
        throw e
      }
    },
    async fetchImportedOrganization() {
      try {
        this.LoadingFetchingOrganization = true
        const { data } = await axios.get(`/api/v1/organizations`, {
          params: {
            old_id: this.userOld.organization_id
          }
        })
        if(data.data && data.data[0] && data.data[0].old_id === this.userOld.organization_id) {
          this.ImportedOrganization = data.data[0]
        }
        this.LoadingFetchingOrganization = false
      } catch (e) {
        console.error(e)
        this.$notify('An error occurred: ' + e.response.data.message, 'error')
        this.LoadingFetchingOrganization = false
      }
    },
    async importOrganization() {
      try {
        if(confirm('Are you sure you want to import this organization?')) {
          this.ValidationErrorMessage = null
          this.LoadingImportingOrganization = true
          const { data } = await axios.post(`/api/v1/import/old-organization/${this.userOld.organization_id}/import`)
          this.ImportedOrganization = data
          this.LoadingImportingOrganization = false
        }
      } catch (e) {
        console.error(e)
        this.LoadingImportingOrganization = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        this.$notify('An error occurred: ' + e.response.data.message, 'error')
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-card :class="[{'bg-green-50': ImportedOrganization}]">
    <tw-loading-spinner v-if="LoadingFetchingOrganization" />
    <div v-if="Organization">
      <tw-button class="float-right" :variant="ImportedOrganization? 'success':'primary'" :loading="LoadingImportingOrganization" @click="importOrganization">
        <span v-if="ImportedOrganization">Re-import</span>
        <span v-else>Import</span>
      </tw-button>
      <h2>{{ Organization.name }}</h2>
      <p>{{ Organization.address }}</p>
      <p>{{ Organization.city }}, {{ Organization.state }} {{ Organization.zip }}</p>
      <div v-if="ImportedOrganization" class="mt-4">
        <import-fundraisers-for-organization :organization="ImportedOrganization" />
      </div>
    </div>
  </tw-card>
</template>

<style scoped>

</style>
